import { TemaCard } from "../models/TemaCardModel";

export const idiomCards: TemaCard[] = [

    new TemaCard(
        'idiom1',
        'Idioms',
        'idiom',
        '¡Qué fuerte!',
        'That’s intense / unbelievable!',
        'Used to react to surprising or shocking news.',
        undefined,
        '¿Te dejó por WhatsApp? ¡Qué fuerte!'
    ),

    new TemaCard(
        'idiom2',
        'Idioms',
        'idiom',
        'estar en las nubes',
        'to be daydreaming / spaced out',
        'Describes someone not paying attention.',
        undefined,
        'Siempre estás en las nubes durante clase.'
    ),

    new TemaCard(
        'idiom3',
        'Idioms',
        'idiom',
        'me suena',
        'sounds familiar to me',
        'Used when something seems vaguely familiar.',
        undefined,
        'Ese nombre me suena, pero no sé de qué.'
    ),

    new TemaCard(
        'idiom4',
        'Idioms',
        'idiom',
        '¡Ni de coña!',
        'No way! / Not a chance!',
        'Informal, emphatic denial or surprise.',
        undefined,
        '¿Vas a correr una maratón? ¡Ni de coña!'
    ),

    new TemaCard(
        'idiom5',
        'Idioms',
        'idiom',
        'estar hecho polvo',
        'to be exhausted / worn out',
        'Very commonly used to express tiredness.',
        undefined,
        'Después del trabajo, estoy hecho polvo.'
    ),

    new TemaCard(
        'idiom6',
        'Idioms',
        'idiom',
        'tirar la toalla',
        'to give up / throw in the towel',
        'Based on boxing; means quitting or surrendering.',
        undefined,
        'No voy a tirar la toalla, seguiré intentándolo.'
    ),

    new TemaCard(
        'idiom7',
        'Idioms',
        'idiom',
        '¡Qué lío!',
        'What a mess! / How confusing!',
        'Used when something is chaotic or complicated.',
        undefined,
        'Entre los papeles y los emails, ¡qué lío!'
    ),

    new TemaCard(
        'idiom8',
        'Idioms',
        'idiom',
        'ser pan comido',
        'to be a piece of cake',
        'Used when something is very easy.',
        undefined,
        'Este examen fue pan comido.'
    ),

    new TemaCard(
        'idiom9',
        'Idioms',
        'idiom',
        'dar en el clavo',
        'to hit the nail on the head',
        'Used when someone makes a perfect observation or action.',
        undefined,
        'Tu comentario dio en el clavo, eso es exactamente lo que pasa.'
    ),

    new TemaCard(
        'idiom10',
        'Idioms',
        'idiom',
        'no hay mal que por bien no venga',
        'Every cloud has a silver lining',
        'This idiom suggests that something good can come from bad situations.',
        undefined,
        'Perdí el tren, pero conocí a una persona interesante. No hay mal que por bien no venga.'
    ),

    new TemaCard(
        'idiom11',
        'Idioms',
        'idiom',
        'más vale tarde que nunca',
        'Better late than never',
        'A way to say that it’s better to do something late than not to do it at all.',
        undefined,
        'Llegué tarde a la fiesta, pero más vale tarde que nunca.'
    ),

    new TemaCard(
        'idiom12',
        'Idioms',
        'idiom',
        'meter la pata',
        'to put one’s foot in one’s mouth',
        'Used when someone says something embarrassing or inappropriate.',
        undefined,
        '¡Ay! Creo que metí la pata con mi comentario.'
    ),

    new TemaCard(
        'idiom13',
        'Idioms',
        'idiom',
        'quedarse de piedra',
        'to be stunned / shocked',
        'Used when someone is completely surprised or shocked.',
        undefined,
        'Me quedé de piedra cuando me dijeron la noticia.'
    ),

    new TemaCard(
        'idiom14',
        'Idioms',
        'idiom',
        'estar como una cabra',
        'to be a bit crazy',
        'Used to describe someone acting a little crazy or silly.',
        undefined,
        'Ese tipo está como una cabra, siempre tiene ideas locas.'
    ),

    new TemaCard(
        'idiom15',
        'Idioms',
        'idiom',
        'tener la sartén por el mango',
        'to be in control / to have the upper hand',
        'Used when someone is in control of a situation.',
        undefined,
        'Cuando él toma una decisión, tiene la sartén por el mango.'
    ),

    new TemaCard(
        'idiom16',
        'Idioms',
        'idiom',
        'dar la campanada',
        'to make a big splash / to make an impression',
        'Used when someone does something extraordinary or stands out.',
        undefined,
        'Cuando publicó su libro, dio la campanada en todo el país.'
    ),

    new TemaCard(
        'idiom17',
        'Idioms',
        'idiom',
        'ser un cero a la izquierda',
        'to be irrelevant / a nobody',
        'Used when someone is considered unimportant or ignored.',
        undefined,
        'En esa reunión, me sentí como un cero a la izquierda.'
    ),

    new TemaCard(
        'idiom18',
        'Idioms',
        'idiom',
        'estar entre la espada y la pared',
        'to be between a rock and a hard place',
        'Used when someone has no good options and must make a tough decision.',
        undefined,
        'Estoy entre la espada y la pared con esta decisión difícil.'
    ),

    new TemaCard(
        'idiom19',
        'Idioms',
        'idiom',
        'hacer la vista gorda',
        'to turn a blind eye',
        'Used when someone ignores something on purpose.',
        undefined,
        'El profesor hizo la vista gorda cuando los estudiantes copiaban en el examen.'
    ),

    new TemaCard(
        'idiom20',
        'Idioms',
        'idiom',
        'estar en las últimas',
        'to be at the end of one’s rope / to be at rock bottom',
        'Used when someone is feeling exhausted or defeated.',
        undefined,
        'Después de la semana de exámenes, estoy en las últimas.'
    ),

    new TemaCard(
        'idiom21',
        'Idioms',
        'idiom',
        'no hay tu tía',
        'There’s no way / impossible',
        'Used to describe something that cannot be done or is extremely difficult.',
        undefined,
        '¿Hacer todo este trabajo en una hora? ¡No hay tu tía!'
    ),

]